import { css } from '@emotion/react';
import React, { useCallback } from 'react';
import {
  Button,
  Icon,
  Navigation,
  NavigationProps,
  Typography
} from '@uniquegood/realworld-studio-design';
import { useLocation } from 'react-router-dom';

import { operation, gameEdit, SectionItem } from '../pages';
import { usePromotionModal } from '@/hooks';
import { PromotionTriggerLocation } from '@/track';

interface SectionWrapperProps {
  type: NavigationProps['type'];
  paths: {
    operation: string[];
    gameEdit: string[];
  };
  onClick: SectionItems[0]['onClick'];
}

type SectionItems = React.ComponentProps<typeof Navigation.Section>['items'];
type MapperType = keyof SectionWrapperProps['paths'];

export default function SectionWrapper({ type, paths, onClick }: SectionWrapperProps) {
  const { pathname } = useLocation();
  const { openPromotionModal } = usePromotionModal();

  const mapper = useCallback(
    (sectionItems: SectionItem[], type: MapperType): SectionItems =>
      sectionItems.map((section, index) => {
        const url = paths[type][index];
        return {
          ...section,
          url,
          onClick,
          selected: pathname.startsWith(url)
        };
      }),
    [paths.gameEdit, paths.operation]
  );

  const operationSection = mapper(Object.values(operation), 'operation');
  const gameEditSection = mapper(Object.values(gameEdit), 'gameEdit');

  const isGameEdit = type === 'gameEdit';

  const handlePlanDetailClick = () => {
    openPromotionModal({ triggerLocation: PromotionTriggerLocation.sidebar_content_management });
  };

  return (
    <>
      <Navigation.Section title="콘텐츠 운영" isTitleHidden={isGameEdit} items={operationSection} />
      {isGameEdit && (
        <div
          css={css`
            width: 50px;
            height: 1px;
            background-color: #555555;
            margin: 8px auto;
          `}
        />
      )}
      <Navigation.Section title="콘텐츠 편집" isTitleHidden={isGameEdit} items={gameEditSection} />

      {!isGameEdit && (
        <div
          css={css`
            height: auto;
            background-color: #1a1a1a;
            border-radius: 16px;
            padding: 16px;
            margin: 24px 8px 0 8px;
            display: flex;
            flex-direction: column;
            gap: 12px;
          `}
        >
          <div>
            <Icon
              icon="jewel_solid"
              size="20px"
              cssStyle={css`
                display: inline-block;
                align-self: flex-start;
              `}
              color="white"
            />
            <Typography
              type="button"
              textColor="white"
              cssStyle={css`
                align-self: flex-start;
                white-space: pre-line;
                font-size: 13px;
              `}
            >
              실감 기술, 추가 AI 크레딧으로{'\n'}몰입도 높은 콘텐츠를 만들어요!
            </Typography>
          </div>
          <Button
            type="primary"
            size="medium"
            cssStyle={css`
              align-self: center;
              background: linear-gradient(90deg, #9243ff 0%, #6997ff 100%);
              border: none;
              &:hover {
                opacity: 0.9;
              }
            `}
            onClick={handlePlanDetailClick}
          >
            요금제 자세히 보기
          </Button>
        </div>
      )}
    </>
  );
}
